import React, { useState } from "react";
import ConfigurationViewService from "../services/configurationview.service";
import { useNavigate } from "react-router-dom";

const CompanyNameEntry = () => {
  const [companyName, setCompanyName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let dashboardName = "CompanyList";
      const response = await ConfigurationViewService.getCompanyURL(
        dashboardName,
        companyName
      );
      console.log(response);

      if (response.status === 200 && response.data?.CompanyURL) {
        let companyURL = response.data.CompanyURL;

        // If the URL is valid and not an empty string, we redirect
        if (companyURL) {
          window.location.replace(companyURL);
        } else {
          setError("Invalid company/Portal name.");
        }
      } else {
        setError("Invalid company/Portal name.");
      }
    } catch (err) {
      console.log(err);
      setError("Company/Portal not found.");
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.box}>
        <h3 style={styles.heading}>Enter Portal Name</h3>

        {/* Divider */}
        <div style={styles.divider}></div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter Portal Name"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            required
            style={styles.input}
          />

          <button className="btn btn-primary w-100" type="submit" style={styles.button}>
            Continue
          </button>
        </form>

        {error && <p style={styles.errorText}>{error}</p>}
      </div>
    </div>
  );
};

// Inline styling
const styles = {
  wrapper: {
    height: "100vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f6fa",
  },
  box: {
    width: "350px",
    padding: "30px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.15)",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
  },
  divider: {
    borderTop: "1px solid #ccc",
    marginBottom: "40px",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  button: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  errorText: {
    color: "red",
    textAlign: "center",
    marginTop: "15px",
  },
};

export default CompanyNameEntry;
